import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";
import "mapbox-gl/dist/mapbox-gl.css";
import "./index.css";
import App from "./App";
import { getBearerToken, pca } from "./services/authService";
import { MsalProvider } from "@azure/msal-react";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Failed to find the root element");
const root = ReactDOM.createRoot(rootElement);
var token = await getBearerToken();

const AppProvider = () => {
  return (
    <MsalProvider instance={pca}>
      <App bearer_token={token} />
    </MsalProvider>
  );
};

root.render(
  <React.StrictMode>
    <AppProvider />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
